<template>
    <div class="check-record-wrap">
        <div>
            <bread-crumb :bread-list="breadList" />
        </div>
        <div class="info-wrap">
            <div class="title-wrap">
                <i class="iconfont icon-tongyongbiaotiicon"></i>
                <span class="title-text">考勤打卡记录</span>
            </div>
            <div class="check-record-out">
                <el-switch
                    v-model="openStatus"
                    active-value='1'
                    inactive-value='0'
                    @change="changeSwitch($event)"
                    active-text="说明：开启后医生播放视频课程时会提示打卡成功，关闭后不再提示"
                    inactive-text="考勤打卡">
                </el-switch>
            </div>
            <div class="table-wrap">
                <el-table :data="recordList"
                          stripe
                          v-loading="loading"
                          style="width: 100%">
                    <el-table-column prop="name"
                                     width="90px"
                                     type="index"
                                     label="序号">
                    </el-table-column>
                    <el-table-column prop="accountName"
                                     min-width="90px"
                                     label="医生姓名">
                        <template slot-scope="scope">
                            {{scope.row.accountName}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="hospitalLevel"
                                     min-width="92px"
                                     label="所属医院">
                        <template>
                            {{ '树兰(杭州)医院' }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="departmentName"
                                     min-width="90px"
                                     label="所属科室">
                        <template slot-scope="scope">
                            {{scope.row.departmentName || '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="phone"
                                     min-width="90px"
                                     label="手机号">
                        <template slot-scope="scope">
                            {{scope.row.phone || '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="title"
                                     min-width="240px"
                                     label="课程名称">
                        <template slot-scope="scope">
                            {{scope.row.title || '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="hospitalPower"
                                     min-width="90px"
                                     label="来源">
                        <template slot-scope="scope">
                            {{scope.row.doctorName || '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="hospitalPowerLevel"
                                     min-width="150px"
                                     label="打卡时间">
                        <template slot-scope="scope">
                            {{scope.row.clockTime || '-'}}
                        </template>
                    </el-table-column>
                    <div slot="empty"
                         class="table-none">
                        <div>
                            <svg-icon icon-class="none1" />
                        </div>
                        <span>暂无数据</span>
                    </div>
                </el-table>
            </div>
            <div class="pagination-wrap">
                <el-pagination background
                               @current-change="pageChange"
                               :current-page.sync="page.current"
                               :page-size="page.pageSize"
                               layout="total, prev, pager, next, jumper"
                               :total="page.total"></el-pagination>
            </div>
        </div>

    </div>
</template>
<style lang="scss">
.check-record-wrap {
    .check-record-out {
        .el-switch__label.is-active {
            color: #666666;
        }
        .el-switch__label {
            color: #666666;
        }
        .el-switch__core {
            background: #cccccc;
        }
        .el-switch .el-switch__core {
            border-color: #cccccc;
            background-color: #cccccc;
        }
        .el-switch__label--right {
            padding-top: 4px;
            color: #999999 !important;
            font-size: 12px;
        }
        .el-switch.is-checked .el-switch__core {
            border-color: #06aea6 !important;
            background-color: #06aea6 !important;
        }
    }
}
</style>
<style lang="scss" scoped>
.info-wrap {
    background-color: #fff;
    box-shadow: 0 1px 4px 0 hsla(0, 0%, 79%, 0.5);
    position: absolute;
    left: 20px;
    right: 20px;
    bottom: 20px;
    top: 50px;
    padding: 20px;
    overflow: auto;
}
.title-wrap {
    font-size: 0;
    padding-bottom: 20px;
    height: 16px;
    line-height: 16px;
    .icon-tongyongbiaotiicon {
        color: $color-primary;
        font-size: 16px;
        vertical-align: middle;
    }
    .title-text {
        font-size: 14px;
        color: #333333;
        margin-left: 10px;
        display: inline-block;
        height: 16px;
        line-height: 16px;
        vertical-align: middle;
    }
}

.table-wrap {
    margin-top: 20px;
    .table-none {
        height: 400px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .icon {
            font-size: 100px;
        }
        span {
            line-height: 14px;
        }
    }
}
</style>
<script>
import { mapGetters } from 'vuex'
import { postCheckList, getCheckData, postCheckData } from '@/api/education'
export default {
    name: 'checkRecord',
    data () {
        return {
            openStatus: '0',
            breadList: [{ label: '继续教育' }, { label: '考勤打卡记录' }],
            page: {
                current: 1,
                total: 0,
                pageSize: 15
            },
            recordList: [],
            loading: true
        }
    },
    computed: {
        ...mapGetters([
            'dictionary'
        ])
    },
    methods: {
        init () {
            this.getData()
            this.getSwitch()
        },
        pageChange (value) {
            this.page.current = value
            this.getData()
        },
        async getData () {
            this.loading = true
            const param = {
                current: this.page.current,
                size: this.page.pageSize
            }
            const { results } = await postCheckList(param)
            this.recordList = results.records || []
            this.page.total = results.total
            this.loading = false
        },
        async getSwitch () {
            this.loading = true
            const { results } = await getCheckData('clockInSwitch')
            this.openStatus = results
            this.loading = false
        },
        async changeSwitch (val) {
            this.loading = true
            let params = {
                configKey: 'clockInSwitch',
                configValue: val
            }
            let text = ''
            const { results, state } = await postCheckData(params)
            if (results === 'ok' && state === 200) {
                if (val === '1') {
                    text = '考勤打卡已打开'
                } else {
                    text = '考勤打卡已关闭'
                }
                this.$message.success(text)
            } else {
                if (val === '1') {
                    text = '考勤打卡打开失败'
                    this.openStatus = '0'
                } else {
                    text = '考勤打卡关闭失败'
                    this.openStatus = '1'
                }
            }
            this.loading = false
        }
    },
    mounted () {
        this.init()
    }
}
</script>
